import { render, staticRenderFns } from "./ListarFuncoesPorRole.vue?vue&type=template&id=6f463b1c&"
import script from "./ListarFuncoesPorRole.vue?vue&type=script&lang=js&"
export * from "./ListarFuncoesPorRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports